import * as zh from './languages/zh';
import * as en from './languages/en';

export default {
    en: en.default, zh: zh.default
};
